import { useState } from 'react';
import AppLayout from '@/components/feature/AppLayout';
import { legalKnowledge } from '@/mocks/systemData';

export default function SupLegalPage() {
  const [legalFilter, setLegalFilter] = useState('all');

  const handleDownload = async (doc: any) => {

    try {

      const response = await fetch(
        'https://guardiancloudcare.com/backend/api/download_legal_pdf.php',
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(doc)
        }
      );

      const blob = await response.blob();

      const url = window.URL.createObjectURL(blob);

      const a = document.createElement('a');

      a.href = url;

      a.download = `${doc.title}.pdf`;

      document.body.appendChild(a);

      a.click();

      a.remove();

      window.URL.revokeObjectURL(url);

    } catch (error) {

      console.error(error);

      alert('Failed to download PDF');

    }

  };

  return (
    <AppLayout title="Legal Reference" breadcrumb={['Supervisor', 'Legal Ref.']}>
      <div className="space-y-4">
        <div className="flex gap-2 flex-wrap">
          {['all', 'law', 'guideline', 'policy'].map((f) => (
            <button key={f} onClick={() => setLegalFilter(f)}
              className={`px-4 py-2 rounded-xl text-sm font-medium transition-colors cursor-pointer whitespace-nowrap capitalize ${legalFilter === f ? 'bg-teal-500 text-white' : 'bg-white border border-gray-200 text-gray-600 hover:bg-gray-50'}`}>
              {f === 'all' ? 'All Documents' : f}
            </button>
          ))}
        </div>

        <div className="space-y-3">
          {legalKnowledge.filter((l) => legalFilter === 'all' || l.type === legalFilter).map((doc) => (
            <div key={doc.id} className="bg-white rounded-xl border border-gray-100 p-5">
              <div className="flex items-start gap-4">
                <div className="w-10 h-10 bg-amber-50 rounded-xl flex items-center justify-center flex-shrink-0"><i className="ri-scales-3-line text-amber-600 text-lg" /></div>
                <div className="flex-1">
                  <div className="flex items-center gap-2 mb-1 flex-wrap">
                    <span className="text-xs font-mono bg-gray-100 text-gray-600 px-2 py-0.5 rounded">{doc.code}</span>
                    <span className={`text-xs px-2 py-0.5 rounded-full font-medium capitalize ${doc.type === 'law' ? 'bg-red-100 text-red-700' : doc.type === 'guideline' ? 'bg-teal-100 text-teal-700' : 'bg-amber-100 text-amber-700'}`}>{doc.type}</span>
                  </div>
                  <p className="text-sm font-semibold text-gray-800 mb-1">{doc.title}</p>
                  <p className="text-xs text-gray-500 mb-3">{doc.description}</p>
                  <div>
                    <p className="text-xs text-gray-400 font-medium mb-1.5">Applicable to:</p>
                    <div className="flex flex-wrap gap-1.5">
                      {doc.caseTypes.map((ct) => <span key={ct} className="text-xs bg-teal-50 text-teal-700 border border-teal-200 px-2 py-0.5 rounded-full">{ct}</span>)}
                    </div>
                  </div>
                </div>
                <button
                  onClick={() => handleDownload(doc)}
                  className="text-xs bg-amber-50 text-amber-700 border border-amber-200 px-3 py-1.5 rounded-lg hover:bg-amber-100 cursor-pointer whitespace-nowrap flex items-center gap-1 flex-shrink-0"
                >
                  <i className="ri-download-line" />Download
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </AppLayout>
  );
}
